
define('app/join/joinApp',[
	'jquery',
	'underscore',
	'backbone',
	'known/knownUtil',
	'known/models/userModel',
	'known/models/leagueInstanceModel',
	'known/collections/leagueInstanceCollection',
	'app/join/views/joinView',
	'module'	
], function(
		$, 
		_, 
		Backbone, 
		KnownUtil, 
		UserModel, 
		LeagueInstanceModel,
		LeagueInstanceCollection,
		JoinView,
		module){
	var initialize = function(){
		var initialModels = KnownUtil.setupSideNav();
		var userModel = initialModels.userModel;
		var userLeagueCollection = initialModels.leagueCollection;
		
		var requestedLeagueJSON = null;
		var requestedErrorJSON = null;
		var leagueModel = null;
		
		if(module.config().requestedLeagueJSON && module.config().requestedLeagueJSON != ''){
			requestedLeagueJSON = $.parseJSON(module.config().requestedLeagueJSON);
			leagueModel = LeagueInstanceModel.findOrCreate(requestedLeagueJSON);
		}
		if(module.config().requestedErrorJSON && module.config().requestedErrorJSON != ''){
			requestedErrorJSON = module.config().requestedErrorJSON;
		}
		
		var joinView = new JoinView({
			userModel: userModel, 
			leagueModel: leagueModel, 
			errorCode: requestedErrorJSON, 
			userLeagueCollection: userLeagueCollection});
		joinView.render();
	};
	
	return {
		initialize: initialize
	};
});